












































































































import {
	computed,
	defineComponent,
	ref,
	watchEffect,
} from '@vue/composition-api';
import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { GroupsBannerStoreV1, GroupsLogoStore, GroupsStore } from '@front-app/store/singletons/Groups';
import { Routes } from '@front-app/constants/routes';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import JoinButton from '@front-app/components/buttons/concrete/JoinButton.vue';
import IconDropdown from '@front-app/components/dropdowns/IconDropdown.vue';
import PublicLink from '@front-app/components/buttons/PublicLink.vue';
import DropdownMenu from '@front-app/modules/group/components/admin/DropdownMenu.vue';
import { canLeave, shouldSeeLeaveWarning } from '@front-app/util/permission';
import { GroupRoleRequest } from '@front-app/services/GroupsApi/GroupsMemberApi';
import { AsyncImage } from '@front-app/store/modules/image';
import { SETTINGS_ICON } from '@front-app/vendor/icon-definitions';
import { useGroupMemberStateChange } from '@front-app/modules/group/hooks/useGroupMemberStateChange';

export default defineComponent({
	components: {
		ColumnContainer,
		DropdownMenu,
		PaddedContent,
		FontAwesomeIcon,
		JoinButton,
		PublicLink,
		IconDropdown,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		numMembers: {
			type: Number,
			required: true,
		},
		isLoadingMembers: Boolean,
		isPinned: Boolean,
		isAdministered: Boolean,
		showJoinLink: Boolean,
		isJoiningGroup: Boolean,
	},
	setup(props, ctx) {
		// Group setup
		const group = computed(() => GroupsStore.getInstance().groupById(props.groupId));
		const currentGroupId = group.value?.id;
		// END Group setup

		// Group image
		watchEffect(() => {
			GroupsLogoStore.fetch(props.groupId);
			const bannerData = group.value?.banner;
			if (bannerData) {
				GroupsBannerStoreV1.fetch(bannerData);
			}
		});
		const logo = computed(() => GroupsLogoStore.get(props.groupId));
		const banner = computed((): AsyncImage | undefined => {
			const bannerData = group.value?.banner;
			if (bannerData) {
				return GroupsBannerStoreV1.get(bannerData);
			}
			return undefined;
		});
		// END Group image

		// Ellipsis menu
		const isEllipsisDropdownOpen = ref(false);
		const canLeaveGroup = computed(() => group.value && canLeave(group.value));
		const confirmLeaveIfNeeded = (): boolean => {
			if (shouldSeeLeaveWarning(group.value)) {
				// eslint-disable-next-line no-alert
				return window.confirm(ctx.root.$t('group.leave.confirmation', [group.value.name]) as string);
			}
			return true;
		};
		const { request: requestStateChange } = useGroupMemberStateChange();
		const leaveGroup = async () => {
			if (group.value && confirmLeaveIfNeeded()) {
				await requestStateChange(group.value.id, GroupRoleRequest.IGNORE);
				ctx.root.$router.push({ name: Routes.GROUPS });
			}
		};
		// End Ellipsis menu

		return {
			// Group info
			group,
			currentGroupId,
			// Images
			logo,
			banner,
			// Ellipsis menu
			isEllipsisDropdownOpen,
			canLeaveGroup,
			leaveGroup,
			// Util
			Routes: {
				GROUP_MAIN: Routes.GROUP_MAIN,
			},
			ButtonPalettes,
			DropdownPositionBottomRight: DropdownPosition.BOTTOM_RIGHT,
			SETTINGS_ICON,
		};
	},
});
